export const ICE_BREAKER_BUTTONS_LIMIT = 4;
